<template>
  <div class="row">
    <div class="col-4">
      <Card>
        <div class="reportee-list">
          <p class="my-0 heading p-3">Your Reportees</p>
          <hr class="my-0" />
          <Input placeholder="Search for Reportee" class="m-3" />
          <div class="px-3">
            <div
              v-for="(employee, index) in employeeList"
              :key="index"
              class="d-flex gap-2 p-2 mb-2 border rounded employee-card"
              @click="navigate()"
            >
              <div>
                <img
                  src="https://www.blexar.com/avatar.png"
                  class="qb-avatar"
                />
              </div>
              <div>
                <p class="my-0">{{ employee.name }}</p>
                <p class="my-0"></p>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
    <div class="col-8">
      <Card>
        <p class="my-0 p-3 pb-0 heading">Tasks to be Reviewed</p>
        <hr />
        <!-- <router-view /> -->

        <div class="mb-2 mx-2">
          <div class="task-card d-flex m-1 p-2 mb-2 justify-content-between">
            <p class="sub-heading my-0">
              Create vue project with mixins and store
            </p>
            <Button
              label="view"
              data-bs-toggle="collapse"
              :data-bs-target="'#collapse'"
              class="qb-btn qb-btn-black-sm"
            />
          </div>
          <div class="collapse task-card m-1 p-2 mb-2" :id="'collapse'">
            <p class="sub-heading my-0">Link :</p>
            <p class="normal-text my-0">submission link</p>
            <p class="sub-heading my-0">Comments :</p>
            <p class="normal-text my-0">comments from user</p>
            <div class="d-flex"><Button label="Go To WorkSheet" class="qb-btn qb-btn-primary-sm my-1" @onClick="goToworksheet()"/></div>
          </div>
        </div>

        <div class="mb-2 mx-2">
          <div class="task-card d-flex m-1 p-2 mb-2 justify-content-between">
            <p class="sub-heading my-0">
              Use all the lifecycle instances in the project
            </p>
            <Button
              label="view"
              data-bs-toggle="collapse"
              :data-bs-target="'#collapse' + 1"
              class="qb-btn qb-btn-black-sm"
            />
          </div>
          <div class="collapse task-card m-1 p-2 mb-2" :id="'collapse' + 1">
            <p class="sub-heading my-0">Link :</p>
            <p class="normal-text my-0">submission link</p>
            <p class="sub-heading my-0">Comments :</p>
            <p class="normal-text my-0">comments from user</p>
            <Button label="Go To WorkSheet" class="qb-btn qb-btn-primary-sm align-self-end my-1" @onClick="goToworksheet()"/>
          </div>
        </div>
      </Card>
      <!-- <Card>
        <div >
          <p class="my-0 p-3 pb-0 heading">Tasks to be Reviewed</p>
          <hr>
         <div v-for="(day,index) in worksheet" :key="index">
            <div class="d-flex content-box">
              <div class="pointer"></div>
              <Card class="pt-0 pb-3 px-3 mx-2 w-25 inner-card">
              {{day.day}}
              </Card>
            </div>
          </div> -->
      <!-- <div v-for="(day,index) in worksheet" :key="index" class="mx-2">
          <div class="content-card p-3 my-2 d-flex rounded"
           data-bs-toggle="collapse"
          :data-bs-target="'#collapse' + index">
            <p class="sub-heading my-0">Create a sample Project</p>
          </div>
          <div class="collapse inner-card border rounded p-2 m-1"
          :id="'collapse' + index">
          <div>
              <p class="sub-heading my-0">Link: </p>
              <p class="my-0 fade-text ms-2">link submitted by the user</p>
              <p class="sub-heading my-0">Comments: </p>
              <p class="my-0 fade-text ms-2">comments to be added </p>
              <Button class="qb-btn qb-btn-primary-md col-3" label="Accept" /> 
            </div>
          </div>
         </div>
        </div>
      </Card> -->
    </div>
  </div>
</template>

<script>
import Input from "../components/TextFieldComponent.vue";
import Card from "../components/CardComponent.vue";
import Button from "../components/ButtonComponent.vue";
export default {
  name: "ReporterPage",
  data() {
    return {
      worksheet: [
        {
          day: "Day 1",
          taskList: [
            { title: "create a sample worksheet" },
            { title: "Learn vue" },
          ],
        },
        {
          day: "Day 2",
          taskList: [
            { title: "create a sample worksheet" },
            { title: "Learn vue" },
          ],
        },
      ],
      employeeList: [{ name: "Monisha A" }, { name: "Aakash V" }],
    };
  },
  components: {
    Card,
    Input,
    Button,
  },
  methods: {
    navigate() {
      this.$router.push({
        name: "ReporteeWorkSheetPage",
        params: { userId: "6371d8dc6dee2a2c747ca4d3" },
      });
    },
    goToworksheet() {
      this.$router.push({path:"module-assigner/6371d8dc6dee2a2c747ca4d3/worksheet/6371d9486dee2a2c747ca4d4"})
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";
.heading {
  font-weight: $font-weight-bold;
  font-size: $font-size-xl;
  text-transform: capitalize;
}
.sub-heading {
  font-weight: $font-weight-bold;
  font-size: $font-size-md;
  text-transform: capitalize;
}
.normal-text {
  font-size: $font-size-md;
  color: $light-600;
}
.content-box {
  border-left: dashed;
  background: transparent;
  padding-bottom: 20px;
}
.pointer {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin-left: -7px;
  background-color: rgb(252, 200, 200);
}
// .inner-card{
//   margin-top: -12px;
// }
.content-card {
  border-left: 3px solid rgb(81, 128, 200);
  background-color: rgb(238, 238, 238);
  cursor: pointer;
}
.qb-avatar {
  width: 35px;
  height: 35px;
  border-radius: 100%;
}
.employee-card {
  cursor: pointer;
}
.fade-text {
  color: $light-500;
  font-size: $font-size-md;
  cursor: pointer;
}
.task-card {
  border: 1px solid $light-200;
  border-radius: $field-border-radius;
}
.reportee-list {
  height: 650px;
}
</style>
